import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const navItems = [
  { label: "Work", href: "#portfolio", testid: "nav-work" },
  { label: "Services", href: "#services", testid: "nav-services" },
  { label: "About", href: "#about", testid: "nav-about" },
  { label: "Journal", href: "#testimonials", testid: "nav-journal" },
  { label: "Contact", href: "#contact", testid: "nav-contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-melissa-bg/80 backdrop-blur-xl border-b border-black/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
        <a href="#top" data-testid="brand-logo" className="flex flex-col leading-none">
          <span className="font-serif text-2xl md:text-3xl tracking-tight text-melissa-ink">
            Melissa O'Donnell
          </span>
          <span className="text-[10px] tracking-overline uppercase text-melissa-inkSoft mt-1">
            Makeup Artistry
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={item.testid}
              className="text-xs uppercase tracking-overline text-melissa-ink hover:text-melissa-rose transition-colors duration-300"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-4">
          <Link
            to="/admin/login"
            data-testid="header-admin-link"
            className="text-[10px] uppercase tracking-overline text-melissa-inkSoft hover:text-melissa-ink"
          >
            Admin
          </Link>
          <a
            href="#contact"
            data-testid="header-book-button"
            className="inline-flex items-center px-5 py-2.5 border border-melissa-ink text-melissa-ink text-xs uppercase tracking-overline hover:bg-melissa-ink hover:text-melissa-bg transition-all duration-300"
          >
            Book a Session
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-melissa-ink"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-melissa-bg border-t border-melissa-border px-6 py-8 flex flex-col gap-6">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`mobile-${item.testid}`}
              className="text-sm uppercase tracking-overline text-melissa-ink"
              onClick={() => setOpen(false)}
            >
              {item.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="mobile-book-button"
            onClick={() => setOpen(false)}
            className="inline-flex items-center justify-center px-5 py-3 border border-melissa-ink text-xs uppercase tracking-overline"
          >
            Book a Session
          </a>
          <Link
            to="/admin/login"
            data-testid="mobile-admin-link"
            className="text-[10px] uppercase tracking-overline text-melissa-inkSoft"
          >
            Admin Sign In
          </Link>
        </div>
      )}
    </header>
  );
}
